/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Card, CardBody, Col } from 'reactstrap';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Text
} from 'recharts';
import { setCurrencyFormat, colorsCombination } from '../../../utils/helpers';

const MonthlyLineChart = ({
  dir, currentYearPrevMonthDayWise, showTitle, month2, month1,
  monthDays, currentYearMonthDayWise, prevYearMonthDayWise, height, showLastYear,
  index
}) => {
  const { t } = useTranslation('common');

  const [color1, color2, color3] = colorsCombination[index % 10];

  const previousMonthDataKey = [`${month2?.month} ${month2?.year}`];
  const currentMonthDataKey = [`${month1?.month} ${month1?.year}`]
  const lastYearMonthDataKey = [`${month1?.month} ${month1?.year - 1}`]
  const dataToShow = []
  for (let i = 1; i <= monthDays; i += 1) {
    const currentMonthAmount = currentYearMonthDayWise?.[i]?.reduce((acc, item) => Number(Number(Number(acc) + Number(item.amount)).toFixed(2)), 0) ?? 0;
    const prevMonthAmount = currentYearPrevMonthDayWise?.[i]?.reduce((acc, item) => Number(Number(Number(acc) + Number(item.amount)).toFixed(2)), 0) ?? 0;
    const prevYearMonthAmount = prevYearMonthDayWise?.[i]?.reduce((acc, item) => Number(Number(Number(acc) + Number(item.amount)).toFixed(2)), 0) ?? 0;

    dataToShow.push({
      [previousMonthDataKey]: prevMonthAmount,
      [currentMonthDataKey]: currentMonthAmount,
      [lastYearMonthDataKey]: prevYearMonthAmount,
      "day": `Day ${i}`
    })
  }

  console.log(dataToShow)

  return (
    <>
      {showTitle ? <div className="card__title">
        <h5 className="bold-text">{t('comparemonthlysales.compareMonth')}</h5>
      </div> : null}
      <div dir="ltr">
        <ResponsiveContainer height={height}>
          <LineChart
            data={dataToShow}
            margin={{
              top: 0, right: 0, left: 25, bottom: 0,
            }}
          >
            <XAxis dataKey="day" reversed={dir === 'rtl'} />
            <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
              tickFormatter={item => setCurrencyFormat(item, true)}
              width={90}
              allowDataOverflow
            />
            <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
            <Tooltip formatter={value => setCurrencyFormat(value, true)} />
            <Legend />
            <Line dot={false} type="monotone" dataKey={currentMonthDataKey?.toString()} stroke={color1 || '#3366ff'} strokeWidth={2} />
            <Line dot={false} type="monotone" dataKey={previousMonthDataKey?.toString()} stroke="#39e600" strokeWidth={2} />
            {showLastYear && <Line dot={false} type="monotone" dataKey={lastYearMonthDataKey?.toString()} stroke={color3 || '#ff33cc'} strokeWidth={2} />}
          </LineChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

MonthlyLineChart.propTypes = {
  dir: PropTypes.string.isRequired,
  currentYearMonthDayWise: PropTypes.object.isRequired,
  prevYearMonthDayWise: PropTypes.object.isRequired,
  monthDays: PropTypes.number.isRequired,
  currentYearPrevMonthDayWise: PropTypes.object.isRequired,
  showLastYear: PropTypes.bool,
  height: PropTypes.number.isRequired,
  showTitle: PropTypes.bool,
  month1: PropTypes.object.isRequired,
  month2: PropTypes.object.isRequired,
  index: PropTypes.number,

};

MonthlyLineChart.defaultProps = {
  showLastYear: false,
  showTitle: true,
  index: 0
}

export default MonthlyLineChart;
